import { useEffect, useState } from 'react'
import { Container } from './styles'
import { iItemIntegracao } from '../../../../../interfaces'
import { appApi } from '../../../../../services/appApi'
interface ICardImersao {
  ImersaoId: string
}

export const CardImersao: React.FC<ICardImersao> = ({ ImersaoId }) => {
  const [Itens, setItem] = useState<iItemIntegracao[]>([])

  useEffect(() => {
    ObterImersao()
  }, [])

  function ObterImersao(): void {
    appApi.get(`Imersao/${ImersaoId}`)
      .then(response => { setItem(response.data.itensIntegracao) }).catch(err => console.error(err))
  }

  return (
    <Container>
      <h3>Lista de itens adicionados</h3>
      {
        Itens.map((e: iItemIntegracao, i): any => {
          return (
            <span key={i}>{i + 1}.  {e.titulo}</span>
          )
        })
      }
    </Container>
  )
}
